export const assessorTable = [
  {
    id: 2,
    label: 'Assessor approve',
    intlKey: 'table.assessor_approve'
  },
  {
    id: 3,
    label: 'Assessor report',
    intlKey: 'table.assessor_report'
  }
]
